import React from "react";
import { Checklist as UIChecklist } from "../../../components/ui";
import { UI_COPY } from "../../../config";
import { useUiText } from "../../../hooks/useUiText";

/**
 * Worker timesheet checklist: requirements before submitting weekly timesheet.
 * Uses generic Checklist from ui with timesheet-specific conditions.
 *
 * @param {Object} props Component props.
 * @param {string} [props.className] Extra wrapper classes.
 * @param {boolean} props.shifts Whether shifts have been clocked.
 * @param {boolean} props.signed Whether the timesheet is signed.
 * @param {boolean} props.saved Whether edits have been saved.
 * @param {boolean} props.safetyMeetingReviewed Whether the safety meeting was reviewed.
 * @returns {JSX.Element}
 */
const Checklist = ({ className, shifts, signed, saved, safetyMeetingReviewed }) => {
  const { t } = useUiText();
  const conditions = [
    { met: shifts, message: t(UI_COPY.timesheet.checklist.clockIn) },
    { met: saved, message: t(UI_COPY.timesheet.checklist.saveChanges) },
    {
      met: safetyMeetingReviewed,
      message: t(UI_COPY.timesheet.checklist.safetyMeeting),
    },
    { met: signed, message: t(UI_COPY.timesheet.checklist.sign) },
  ];

  return (
    <UIChecklist
      className={className}
      conditions={conditions}
      successMessage={t(UI_COPY.timesheet.checklist.allMet)}
    />
  );
};

export default Checklist;
